import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/** One credit pack: name, price, value lines and a buy button. */
export function CreditPackCard({
  name,
  price,
  lines,
  badge,
  buyLabel,
  busyLabel,
  busy,
  disabled,
  onBuy,
}: {
  name: string;
  price: string;
  /** First line is emphasized (the credit amount). */
  lines: readonly string[];
  /** Highlights the card ("Most popular"). */
  badge?: string;
  buyLabel: string;
  busyLabel: string;
  busy: boolean;
  disabled: boolean;
  onBuy: () => void;
}) {
  return (
    <div
      className={cn(
        'relative flex flex-col gap-5 rounded-2xl border border-border bg-card p-6 sm:p-8',
        badge && 'border-primary shadow-lg shadow-primary/10 ring-1 ring-primary',
      )}
    >
      {badge ? (
        <span className="absolute -top-3 left-6 rounded-full bg-primary px-2.5 py-0.5 text-xs font-semibold text-primary-foreground">
          {badge}
        </span>
      ) : null}
      <div>
        <p className="text-sm font-semibold text-foreground">{name}</p>
        <p className="mt-2 text-4xl font-bold tracking-tight">{price}</p>
      </div>
      <ul className="space-y-2 text-sm text-muted-foreground">
        {lines.map((line, index) => (
          <li key={index} className={index === 0 ? 'font-medium text-foreground' : undefined}>
            {line}
          </li>
        ))}
      </ul>
      <Button size="lg" className="mt-auto w-full" variant={badge ? 'default' : 'outline'} disabled={disabled} onClick={onBuy}>
        {busy ? (
          <>
            <Loader2 className="size-4 animate-spin" aria-hidden="true" />
            {busyLabel}
          </>
        ) : (
          buyLabel
        )}
      </Button>
    </div>
  );
}
